import {
    setGlobalState
} from '../Networks/QuestionState';

let setData;
let apiUrl = 'https://api.nigeriacsi.org';

// if (window.location.href.includes('localhost')) {
//   apiUrl = 'http://localhost:8000';
// }
const useFetch = () => {
    fetch(apiUrl)
        .then((response) => response.json())
        .then((json) => {
            // An empty or malformed payload would blank out every question, so
            // keep the bundled sample data instead of overwriting it.
            if (!Array.isArray(json) || json.length === 0) {
                return setData;
            }
            setData = json
            setGlobalState('sample', json)
            return setData;
        })
        .catch(() => {
            // Unreachable API: fall back to the bundled sample data.
            return setData;
        });
    return setData;
}

export default useFetch;